import React from "react";
import styled from "styled-components";

const ErrorMessage = styled.span`
    font-size: 75%;
    color: #cc6666;
`;

export default ErrorMessage;
